import React from 'react';
import DropdownMechanismNoLabel from '../../GeneralComponents/DropdownMechanismNoLabel';

/* This component is used inside ProjectsTable tableHead and represents the dropdown mechanism that is used 
*  next to state and role title fields to filter the displayed rows based on user's selection.It takes as an  
*  argument the filterOptions, a callback function to set the desired user's option and a function updateFilter 
*  which updates the status of filter in database side.
*/
const FilterComp = (props) => {

    const {
        setFilter,
        filterOptions,
        updateFilter
    } = props;

    const selectFilterOption = (option) => {
        setFilter(option);
        updateFilter(option);
    }

    return(
        <div style={{display: 'inline-flex'}}>
            <DropdownMechanismNoLabel
                targets={filterOptions}
                selectTarget={selectFilterOption}
            />
        </div>
    )

}

export default FilterComp; 